import {
  withFormsy,
} from 'formsy-react';

import InputTypeaheadView from './InputTypeaheadView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputTypeaheadView);

const Component = InputComponent;

export default Component;
